import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { FINAL_CTA, SITE } from "@/lib/site";

export const FinalCTA = () => {
  return (
    <section data-testid="final-cta" className="py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="relative rounded-[2rem] overflow-hidden bg-gradient-to-br from-blue-900 via-blue-800 to-blue-950 text-white px-8 md:px-16 py-16 md:py-20">
          <div className="absolute inset-0 opacity-30 pointer-events-none">
            <div className="absolute -top-24 -right-24 h-72 w-72 bg-blue-400 rounded-full blur-3xl" />
            <div className="absolute -bottom-24 -left-24 h-72 w-72 bg-sky-300 rounded-full blur-3xl" />
          </div>
          <div className="relative grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <div className="text-xs uppercase tracking-[0.22em] font-semibold text-blue-200">
                Book an Appointment
              </div>
              <h2 className="mt-4 font-serif text-3xl md:text-5xl leading-tight tracking-tight text-white">
                {FINAL_CTA.heading}
              </h2>
              <p className="mt-5 text-blue-100/80 leading-relaxed max-w-lg">
                {FINAL_CTA.paragraph}
              </p>
            </div>
            <div className="md:justify-self-end flex flex-col gap-4 w-full md:w-auto">
              <Link
                to="/contact"
                data-testid="final-cta-book"
                className="inline-flex items-center justify-center gap-2 bg-white text-blue-950 font-semibold px-8 py-4 rounded-full hover:bg-blue-50 transition-colors"
              >
                Book a Consultation
                <ArrowRight className="h-4 w-4" />
              </Link>
              <a
                href={`tel:${SITE.phoneRaw}`}
                data-testid="final-cta-call"
                className="inline-flex items-center justify-center gap-2 border border-white/30 text-white font-semibold px-8 py-4 rounded-full hover:bg-white/10 transition-colors"
              >
                <Phone className="h-4 w-4" />
                Call for Appointment
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
